import script from "./qa.vue?vue&type=script&setup=true&lang=js"
export * from "./qa.vue?vue&type=script&setup=true&lang=js"

import "./qa.vue?vue&type=style&index=0&id=6eb33076&lang=scss"

const __exports__ = script;

export default __exports__